<template>
	<div>
		<el-dialog title="修改发货时间" @close="cancel()" :visible.sync="dialog.syncOrderDialog" width="500px" center >
			<div class="opts_wrap" v-loading="loading">
				<div class="opts_line">
					<p class="txt">
						<span class="label">选择发货时间：</span>
						<span class="val">
							<el-select size="small" class="" v-model="delivery_delay_day" placeholder="请选择" clearable>
								<el-option v-for="(item,index) in deliver_enums" :key="index" :label="item.label" :value="item.day">
								</el-option>
							</el-select>
						</span>
					</p>
				</div>
				
				<div class="btn_wrap">
					<p class="btn" @click="bindSubmit()">提交</p>
					<p class="btn" @click="cancel()">关闭</p>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
export default {
	name: "editDeliveryDay",
	props: {
		isLoading: {
			type: Boolean,
			default: false
		},
		show: {
			type: Boolean,
			default: false
		},
		id: {
			type: Array,
			default: () => {
				return []
			}
		},
		params: {
			type: Object,
			default: ()=> {
				return {}
			}
		}
	},
	data() {
		return {
			dialog: {
				syncOrderDialog:false,
			},
			deliver_enums:'',
			loading: false,
			delivery_delay_day: '',
		};
	},
	
	created(){
	},
	mounted() {
	},
	
	computed:{
		...mapState({
		}),
	},
	watch:{
		show(val) {
			if(val){
				this.deliver_enums = []
				this.init()
			}
		}
	},
	
	methods: {
		...mapActions({
			getDeliverEnums:"ucenter/getDeliverEnums",
			postBatEditDeliveryDay:"ucenter/postBatEditDeliveryDay",
		}),
		init(){
			this.loading = true
			this.getDeliverEnums({data:{},success:(res)=>{
				if(res.code===200){
					this.deliver_enums = res.data
					this.dialog.syncOrderDialog = true
					console.log(333,this.deliver_enums)
				} else {
					this.$message({message: res.msg,type: 'error',})
					this.$emit('close', {})
				}
				this.loading = false
			}})
		},
		
		bindSubmit(){
			let params = {...this.params,ids:this.id,delivery_delay_day:this.delivery_delay_day}
			console.log(params)
			if(this.loading){
				return
			}
			this.loading = true
			
			this.postBatEditDeliveryDay({data:params,success:(res)=>{
				if(res.code === 200){
					this.$message({message: res.msg,type: 'success',});
					this.$emit('close', {})
					this.dialog.syncOrderDialog = false
					this.form = {}
				}else{
					this.$message({message: res.msg,type: 'error',});
					this.$emit('close', {})
				}
				this.loading = false
			}})
	
		},
		cancel(){
			this.$emit('close', {})
			this.dialog.syncOrderDialog = false
		}
	},

}
</script>

<style scoped>
	.opts_wrap{padding-top: 14px;}
	.opts_wrap .opts_line{margin-top: 20px;display: flex;align-items: center;}
	.opts_line .txt{width: 100%;font-size: 16px;display: flex;align-items: center;}
	.opts_line .txt .label{min-width: 80px;display: inline-block;}
	.opts_wrap .btn_wrap{margin: 40px auto 0 auto;display: flex;align-items: center;justify-content: center;}
	.opts_wrap .btn_wrap .btn{width: 80px;height: 34px;border-radius: 4px;display: flex;justify-content: center;align-items: center;cursor: pointer;box-sizing: border-box;font-size: 14px;}
	.opts_wrap .btn_wrap .btn:nth-child(1){background: var(--red);color: #fff;margin-right: 14px;}
	.opts_wrap .btn_wrap .btn:nth-child(2){background: #fff;color: #333;border: 1px solid #ddd;margin-right: 14px;}
	.ml8{margin-left: 8px;}
	.opts_wrap .btn_wrap .btn:nth-child(3){background: #fff;color: #333;border: 1px solid #ddd;}
	.w80{width: 80px;}
	.el-icon-document-copy{cursor: pointer;}
	
	.el-input--suffix .el-input__inner{padding: 0 0 0 12px !important;font-size: 16px;}
	/*red border color*/
	.el-input__inner:focus ,.el-select .el-input.is-focus .el-input__inner ,.el-select .el-input__inner:focus ,.el-radio__input.is-checked .el-radio__inner ,.el-radio__inner:hover{border-color: var(--red);}
	
	/*red color*/
	.el-select-dropdown__item.selected ,.el-radio__input.is-checked+.el-radio__label{color: var(--red);}
	
	/*red background color*/
	.el-radio__input.is-checked .el-radio__inner{background-color: var(--red);}
	.el-date-editor{margin-top: unset;}
</style>
